module.exports = __webpack_public_path__ + "static/media/icon_114.b83e3b2a.svg";